import { X } from 'lucide-react';
import { NewDesignScope } from '../../NewDesignScope';
import { Button } from '../../ui/button';
import { PopupThemeContext } from '../../ui/popup-theme';
import { ProjectListRow, ProjectListRowStub } from '../list/ProjectListRow';
import { useProjectById } from '../useProjectById';

/**
 * Проект во вложении сообщения мессенджера (концепт project-to-chat 2.2, 3.2): та же строка-карточка, что в списке проектов,
 * в тёмной теме списка и его ширины (340 px — колонка списка в окне 1440). Данные живые — из entity-кэша, как у списка.
 * Нажатие — onOpen (открыть проект). С onRemove — карточка над полем ввода: вместо точек отметок кнопка «Убрать».
 * name — название из сообщения: им подписана карточка, пока проект грузится или если он удалён либо недоступен.
 */
export function ProjectChatCard({
  projectId,
  name,
  onOpen,
  onRemove,
}: {
  projectId: string;
  name: string;
  onOpen: (projectId: string) => void;
  onRemove?: () => void;
}) {
  const { project, query } = useProjectById(projectId);

  return (
    <NewDesignScope className="nd:w-[21.25rem] nd:max-w-full nd:whitespace-normal">
      <div className="dark nd:relative nd:text-foreground">
        <PopupThemeContext.Provider value="dark">
          {project ? (
            <ProjectListRow
              project={project}
              selected={false}
              onSelect={onOpen}
              flags={!onRemove}
              className={onRemove ? 'nd:pr-10' : undefined}
            />
          ) : (
            <ProjectListRowStub name={name} unavailable={query.isError} />
          )}
          {onRemove ? (
            <Button
              variant="ghost"
              size="icon-sm"
              aria-label="Убрать проект"
              className="nd:absolute nd:top-1/2 nd:right-1 nd:-translate-y-1/2 nd:text-muted-foreground"
              onClick={onRemove}
            >
              <X />
            </Button>
          ) : null}
        </PopupThemeContext.Provider>
      </div>
    </NewDesignScope>
  );
}
